/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsGetAodRunsOneAugmentedQueryResponse, AuditReportsGetAodRunsOneAugmentedPathParams, AuditReportsGetAodRunsOneAugmentedQueryParams, AuditReportsGetAodRunsOneAugmented401, AuditReportsGetAodRunsOneAugmented403 } from "../models/AuditReportsGetAodRunsOneAugmented";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { auditReportsGetAodRunsOneAugmented } from "../axios/auditReportsGetAodRunsOneAugmented";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const auditReportsGetAodRunsOneAugmentedQueryKey = (id: AuditReportsGetAodRunsOneAugmentedPathParams["id"], params: AuditReportsGetAodRunsOneAugmentedQueryParams = {}) => ["api-v2", { url: '/audit-reports/v1/aod-runs/:id', params: {id:id} }, ...(params ? [params] : [])] as const

export type AuditReportsGetAodRunsOneAugmentedQueryKey = ReturnType<typeof auditReportsGetAodRunsOneAugmentedQueryKey>

export function auditReportsGetAodRunsOneAugmentedQueryOptions(id: AuditReportsGetAodRunsOneAugmentedPathParams["id"], params?: AuditReportsGetAodRunsOneAugmentedQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = auditReportsGetAodRunsOneAugmentedQueryKey(id, params)
        return queryOptions<AuditReportsGetAodRunsOneAugmentedQueryResponse, ResponseErrorConfig<AuditReportsGetAodRunsOneAugmented401 | AuditReportsGetAodRunsOneAugmented403>, AuditReportsGetAodRunsOneAugmentedQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return auditReportsGetAodRunsOneAugmented(id, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Retrieve a single AodRun
 * {@link /audit-reports/v1/aod-runs/:id}
 */
export function useAuditReportsGetAodRunsOneAugmented<TData = AuditReportsGetAodRunsOneAugmentedQueryResponse, TQueryData = AuditReportsGetAodRunsOneAugmentedQueryResponse, TQueryKey extends QueryKey = AuditReportsGetAodRunsOneAugmentedQueryKey>(id: AuditReportsGetAodRunsOneAugmentedPathParams["id"], params?: AuditReportsGetAodRunsOneAugmentedQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<AuditReportsGetAodRunsOneAugmentedQueryResponse, ResponseErrorConfig<AuditReportsGetAodRunsOneAugmented401 | AuditReportsGetAodRunsOneAugmented403>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? auditReportsGetAodRunsOneAugmentedQueryKey(id, params)
         

         const query = useQuery({
          ...auditReportsGetAodRunsOneAugmentedQueryOptions(id, params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<AuditReportsGetAodRunsOneAugmented401 | AuditReportsGetAodRunsOneAugmented403>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}